import { rest } from 'lodash';
import React from 'react';
import { Image } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const Logo = ({ ...rest }) => {

  const themeState = useSelector(state => state.themeState);

  return (
    <div>
      <Image
        src={themeState.themeMode === 'dark' ? '/assets/images/premier-logo-dark.svg' : '/assets/images/logo-premier.svg'}
        alt="Logo"
      />
    </div>
  );
};

export default Logo;
